import z from "zod";
import { FILE_COLLECTION_TABLES } from "../../../types/files";
import { existingFileIdsSchema } from "./existing-file-ids.schema";
import { uploadResultsSchema } from "./upload-results.schema";

export const postForeignFileParamSchema = z.object({
	tableName: z.enum(FILE_COLLECTION_TABLES),
});

/**
 * The body of a link request: which parent the files hang on, and which files.
 *
 * *Which* columns `foreignKeyValues` names is not checked here and cannot be — the collection is in
 * the path and the columns are in the body, and no validator sees both. The registry checks them,
 * against the same list this schema's `tableName` is drawn from. That there is at least one is
 * checkable here, and is refused here: every collection's parent columns are `NOT NULL`, and an
 * empty object gives the proof loop nothing to iterate over, so it reaches the insert and dies on
 * the constraint instead of being answered as the malformed request it is.
 */
export const postForeignFileJsonSchema = z
	.object({
		foreignKeyValues: z
			.record(z.string(), z.uuid())
			.refine((values) => Object.keys(values).length > 0, {
				message: "foreignKeyValues must name at least one parent column",
			}),
	})
	.and(uploadResultsSchema.partial())
	.and(existingFileIdsSchema.partial());
